import React from 'react';
import Autosuggest from 'react-autosuggest';

// Imagine you have a list of languages that you'd like to autosuggest.

const list = [
  'Ministère de la Justice et Droits Humains',
  'Organisation de la Société Civile',
  "Ministère de l'Administration",
  'Organisation non gouvermental',
  "Ministry of Interior / Ministère de l'Intérieur",
  'The Home Ministry affairs',
  "Agence Burundaise de Promotion de l'investissement",
  'Ministère des affaires étrangères',
  "Ministère de l'Intérieur",
  'Ministry of home security',
  'Prefecture',
  'Department of Civil & National Registration',
  'Ministere des droits humains',
  'Ministère de la Justice et Garde des sceaux',
  'Health ministry',
  'Ministere de la justice et droits humains',
  'Parquet des grandes instances de Bunia',
  'ONG ALDI',
  'divisions:PLAN, AFFAIRE SOCIALE,JUSTICE,CULTURE ET ARTS,ENVIRONNEMENT',
  'Ministère des Affaires Sociales et Ministère de Justice',
  'The plan Ministry , Justice Division , Social Affaires ministry , North Kivu Goverment , ECOSOC/UN',
  'Ministry of the Interior',
  "Ministère de l'Administration du Territoire et de la Décentralsiation",
  "Ministère de l'Intérieur",
  'Ministère des Affaires Etrangères',
  'Minister of Education',
  "Ministry of Territorial Administration and Decentr…tion / Ministère de l'Administration territoriale",
  'Préfecture',
  'Delegation of Public Health south west region and Divisional administration department',
  'RESEAU NADA',
  'The Ministry of Social Solidarity',
  'Social Affairs',
  'The Federal Charities and Societies Agency',
  'Ministry of Trade',
  'Ministry of the Interior of Security and Immigrati…l Administration of Decentralization and Security',
  'Ministry of Gender, Children and Social Protection (MoGCSP)',
  "Registrar General's Department",
  'Department of Social Welfare of the Ministry Gender Children and Social Protection.',
  'Deparment of Social Affairs',
  'Corporate Affairs Commission, Federal Republic of Nigeria',
  'Department of Justice',
  'Registrar of Companies, AG Chambers',
  "Ministère de l'administration du Térritoire et de la Décentralisation",
  'The Registrar of Societies',
  'Ministry of Lands',
  'Companies Act (Cap 486), Government of Kenya',
  'Ministry of Children, Genders and Social Development',
  'NGOs Coordination Board',
  'Ministry of Labour, Social Security and Services',
  'Social services ministry of youths',
  'NGO Coordination Board',
  'State Law Office',
  'NGO Registration Bureau',
  'The Non-Governmental Organizations Co-ordination Board (Kenya)',
  'Ministry of State for National Heritage and Culture, Office of the Vice President, Kenya',
  'Liberia Business Registry',
  'Ministry of Foreign Affairs',
  'Ministry of Finance and Development Planning / NGO Division',
  'Liberia Medical and Dental Council (LMDC)',
  'Liberia Business Registry',
  'Ministry of Commerce',
  'the Ministry of solidarity, Women and the Family.',
  'Wilaya of Casablanca',
  'Ministère de la Population, de la Protection Sociale et de la Promotion de la Femme',
  'Gouvernorat du District de Bamako',
  "Ministère de l'administration Territoriale",
  "Direction Generale de l'Administration du Territoi…e la decentralisation et de la reforme de l'etat)",
  "Ministère de l'intérieur",
  'Registrar of Associations Government of Mauritius',
  'Ministry of Justice and Constitutional Affairs',
  'Non-Government Organization Board of Malawi',
  'Organisation Non Gouvernementale',
  "Ministère de l'intérieur",
  'Corporate Affairs Commission (CAC)',
  'Nigeria',
  'Kano State Community Development Associations',
  'Onitsha North Local Government Council',
  'Ministry of Women Affairs',
  'Companies House',
  'Kaduna State Ministry of Youths and Sports',
  'NATIONAL DRUG LAW ENFORCEMENT AGENCY & INDEPENDENCE CORRUPT PRACTICES AND OTHER RELATED OFFENCES',
  'Federal, State and Local government respectively',
  'Federal Ministry of Education',
  'Federal Ministry of Health',
  'Rwanda Governance Board (RGB)',
  'Citizen Engagement Platform Seychelles',
  'Ministry of security and social Development(MSSD) - Humanitarian Aid Commission ( HAC)',
  'Ministry of Labor and Administrative Reform',
  'The Cooperate Affairs Commission Sierra Leone',
  'Kailahun Local Government Council',
  'Ministry of Finance',
  "Ministry of Agriculture Forest y and Food Sequitur…try of Social Welfair Gender & Children's Affairs",
  'Ministry of Development and Economic Planning, Min…iation of Non Governmental Organizations (SLANGO)',
  "Ministère de l'intérieur et Ministère du Commerce",
  "Ministère de l'intérieur",
  'Gouvernance',
  'GIE',
  'Ministry of Foreign Affairs',
  'Koungheul',
  'Structure Gouvernementale',
];

const donor_list = [
  'Access Bank',
  'Access to Security and justice Programme',
  'ACT Foundation',
  'ACTED\n',
  'Action Solidarité Tiers Monde',
  'ActionAid',
  'ACTIONAIDS NIGERIA',
  'ADF/Field Office',
  'African Capacity Building Foundation (ACBF)',
  'African Economic Research Consortium',
  'African Palliative Care Association',
  'African Women Development Fund',
  'Aga Khan Foundation',
  'AGAIB',
  'Agakhan Foundation',
  'AIDS Healthcare Foundation',
  'AIDSCare Foundation',
  'AIDSFONDS',
  'AMBASSADE DE NORVEGE/ Norway Embassy',
  'AMBASSADE DU CANADA / Canada Embassy',
  'Ambassade du Japon en R.D.Congo',
  'American Cancer Society',
  'Amnesty International',
  'AMPLIFYCHANGE',
  'AMPLIFYCHANGE',
  'Andrew YOUNG Foundation, PROMETRA USA, Superior Learning and Research Ministry',
  "Anglo-American Chairman's Fund",
  'Annie Lennox Foundation',
  'Anonymous and Paypal Donations',
  'Anthony Robbins Foundation',
  'APHRC',
  'Ariel Foundation International',
  'ASHAIMAN MUNICIPAL ASSEMBLY',
  'Assemblée Générale',
  'Association des Eglises Evangeliques du Bénin',
  'Australian High Commission',
  'AVI Community Grants',
  'BasicNeeds, UK/Grand Challenge Canada',
  'Baywater Nig Ltd',
  'Bertha Foundation',
  'Blue Label Telecoms',
  'Board members',
  'Board of Trustee (BOT)',
  'British Council',
  'Butterflyworks',
  'BWB-kanthari',
  'Canada Fund for Local Initiatives',
  'Canadian fund for Local Initiative',
  'CAPDA',
  'CARE International',
  'Catalyst Exhibits, USA',
  'Catholic Relief Services (CRS)',
  'Cellule filets sociaux',
  'CENTRE FOR DEVELOPMENT PARTNERSHIP',
  'Charity Aids Foundation',
  'Charity Aids Foundation',
  'Children of Cameroon- UK',
  'Citi Foundation',
  'CIVICUS',
  'Claude Leon Foundation',
  'Clinical Translational Scientfic Research',
  'Comic Relief',
  'Comité Français pour la Solidarité Internationale',
  'Commonwealth Foundation',
  'Communication for Change (C4C)',
  'Community System Strenghthening (CSS)',
  'CONSORTIUM OF NGOs IN TEMA',
  'Coopération Belge',
  'Cooperation Suisse',
  'Coronation Bank',
  'CREEK Foundation',
  'D. Dalton, USA',
  'Deloitte',
  'DEMOCRACY INTERNATIONAL',
  'Diamond Bank',
  'Disability Right Fund',
  'Distell Development Trust',
  'DreamOval Limited',
  'Education Universelle en Afrique',
  'Edukans foundation',
  'Egyptian Swiss Fund',
  'Embassy of France / Ambassade de france',
  'Embassy of SWISSZERLAND',
  'Engenderhealth',
  'Equal Measures 2030',
  'Equilibre et Population',
  'Equity',
  'Eriks Development Partners',
  'EU Media Focus',
  'European Commission',
  'European Union / Union Européenne',
  'European Union / Union Européenne',
  'Even Ground',
  'Exim-Bank-Ghana',
  'ExxonMobil',
  'Fairheads Foundation',
  'FAP NGO Cameroon',
  'FIDELIA ASSURANCE',
  'Firelight Foundation',
  'FIRST RAND FOUNDATION',
  'FirstRand Foundation',
  'FirstRand Trust',
  'Flickers of Hope Foundation',
  'Foam',
  'Fondation de France',
  'Fondation Doen',
  'Fondation Follereau de Luxembourg',
  'Fondation Rainbow Solidarité',
  'Fondation Rosa Luxembourg',
  'FONDATION TIDES',
  'Fonds Humanitaire',
  'Food and Agriculture Organization of the United Nations (FAO)',
  'Ford Foundation',
  'Foundation for Civil Society',
  'Foundation for Civil Society',
  'FOUNDATION FOR CIVIL SOCIETY TANZANIA',
  'Friends of VOICE GHANA',
  'Fulton Trust',
  'Fundraising',
  'Gates Foundation',
  'GGF-international',
  'GHANA AIDS COMMISSION',
  'Girls Not Brides',
  'Global Affairs Canada (GAC)',
  'Global Center for Cooperative and Security',
  'GLOBAL FUND',
  'Global Neighborhood Fund',
  'GlobalGiving',
  'GMM-UK',
  'Google Inc',
  'Grace Notes- USA',
  'GRADH',
  'Grant/Civil Society in Malaria Control,',
  'Green Globe SME Funds',
  'Gret/France',
  'HANDICAP iNTERNATIONAL',
  'HCI Foundation',
  'HEALTH ALIVE FOUNDATION',
  'HEARTLAND ALLIANCE INTERNATIONAL',
  'Hewlett Foundation',
  'HIV Alliance - Netherlands',
  'Hospice Community Care Lancaster',
  'Huairou Commission',
  'Human Dignity Foundation',
  'IHAI-EASHRI',
  'Immunization and Nutrition(ACOMIN)',
  'Industrial Development Corporation',
  'Informatik Afrika, Switzerland',
  'International ANALOG forestry',
  'International Center For Soil Fertility and Agricultural Development',
  'International Development Research Centre (IDRC)',
  'International Foundation for Science',
  'International Organization for Migration',
  'International Solidarity Foundation',
  'Investec',
  'Iqraa Trust',
  'IRD',
  'islamic relief',
  'Japan Social Development Fund',
  'Japanese cooperation',
  'Japanese cooperation',
  'Johnsnow Inc.',
  'JSI',
  'K4Health',
  'katharine Loanzon- USA',
  'Keeper of the earth foundation',
  'Kenya Community Development Foundation',
  'KFC Social Responsibility Trust',
  'Kirsh Foundation',
  'Konrad Adenaure Foundation',
  'Kresge Foundation (USA)',
  'Lafarge Africa Plc',
  'Lafarge Africa Plc',
  'Lafarge Africa Plc',
  'Lambent Foundation',
  'Lift Above Poverty Organisation (LAPO)',
  'Light for the World',
  'Lilian Foundation Netherlands',
  'LitWorld',
  'LIVING EARTH',
  'LOGODEP',
  'LUCAS/Suisse',
  'Lush South Africa',
  'M. Night Shyamalan Foundation',
  'MacArthur Foundation',
  'Mai Family Foundation',
  'MAID Foundation',
  'Malala Fund',
  'Malteser International',
  'MANAGEMENT SYSTEM INTERNATIONAL',
  'Mapula Trust',
  'Maria Ebun Foundation',
  'Mary Slack & Daughters Foundation',
  'mastercard foundation',
  'Meda Pharma',
  'Medecins sans Frontieres',
  'Medical Teams International',
  'Members',
  'Mennonite Central Committee',
  'Mercy Corps',
  'Mercy Relief',
  'Microsoft',
  'Ministere de la Culture',
  'Ministry of Agriculture',
  'Ministry of Budget and economic planning,',
  'Ministry of Gender, Children and Social Protection',
  'Ministry of Health',
  'Ministry of Human Rights',
  'Ministry of Justice',
  'Ministry of Justice',
  'MIVA',
  'Motorola',
  'Motsepe Foundation',
  'Mutual & Federal Community Trust',
  'National Council for Childhood and Motherhood',
  'National CSR Foundation',
  'National Endowment for Democracy',
  'National Geographie',
  'NATIONAL MALARIA CONTROL',
  'Nedbank Foundation',
  'Netherlands Organization for Scientific Research',
  'New England Biolabs Foundation',
  'NGO Trust Fund',
  'Nigeria Foundation for Support of Victims of Terrorism (Victims Support Fund)',
  'Nigeria Stability and Reconciliation Programme',
  'Nikon Camera Makers',
  'Norwegian Agency for Development Cooperation',
  'OAK FOUNDATION',
  'OCAL',
  'Old Mutual Foundation',
  'Onelife Initiative For Human Development',
  'ONG Italienne AVSI',
  'ONU Femmes',
  'OPEN SOCIETY FOUNDATION',
  'Open Society Initiative for South Africa',
  'OPEN SOCIETY INITIATIVE FOR WEST AFRICA (OSIWA)',
  'Open Society of West Africa',
  'OPNE SOCIETY FONDATION',
  'Oppenheimer Memorial Trust',
  'Organisation internationale de la Francophonie',
  'Osisa',
  'Oxfam',
  'Paladuim',
  'Pan American Health Organization (PAHO)',
  'Paul Peck, USA',
  'Peace Direct',
  'Peugeot',
  'pgrcdu',
  'PHARO FOUNDATION',
  'Plan International',
  'Planète Urgence',
  'Pompedou Paris',
  'Positive Action for Childern',
  'Prinsen Bernard Fund',
  'Private Health Sector Alliance',
  'Private Sector',
  "Programme d'Appui au Secteur Agricole/Gouvernement",
  'Programme Nationale de lutte contre le sida',
  'PROMAP',
  'Raith Foundation',
  'Rapid Response',
  'REPSSI',
  'Rev. C.F. Johnston Foundation',
  'REWARD',
  'Rights & Resources Initiative',
  'Rockdale Foundation',
  'Rockefeller foundation',
  'Rockerfeller Foundation',
  'Royal Heritage Health Foundation (Secure Livelihood)',
  'Rutgers',
  'Rwanda Governance Board (RGB)',
  'SAGE Foundation',
  'SAGE Foundation',
  'Sakata',
  "Samaritan's Purse",
  'Save the Children',
  'Sawers Foundation for Development',
  'Sawers Foundation for Development',
  'SBM Foundation',
  'Search for common ground',
  'Segal Family Foundation',
  'Segal Family Foundation',
  'Self funded',
  'Selfless4Africa',
  'Seva Foundation',
  'Skills for Development UK',
  'Slow food International',
  'SNV Netherlands',
  'Social Fund for Development',
  'SOCIETY FOR FAMILY HEALTH',
  'SOFEPADI',
  'Solon Foundation',
  'South African Revenue Service',
  'STAR-GHANA',
  'Stars foundation',
  'Stephen Lewis Foundation',
  'Street Child',
  'Street Kids International',
  'Support program for Agri-food enterprises',
  'Sustainable Sanitation Alliance',
  'Sweden NORAD',
  'Swedish International Development Cooperation Agency (Sida)',
  'Swedish International Development Cooperation Agency (Sida)',
  'Swift Foundation',
  'Swiss Development Cooperation',
  'Swiss Philanthropist',
  'Swissaid',
  'Teach For All',
  'Tearfund',
  'Terra Tech',
  'The Baring Foundation /DDP/Ockenden/JOAC',
  'the David and Lucile Packard Foundation',
  'The ELMA Foundation',
  'The Girl Generation',
  'The Learning Trust',
  'TJF Charitable Trust',
  'TMSS[43]',
  'TOGOCEL',
  'Tree of Life Foundation',
  'Trickle Up',
  'Trust Africa',
  'TrustAfrica',
  'U.S. EMBASSY',
  'UK Embassy',
  'UN WOMEN',
  'UNA Sweden',
  'UNDAIDSFONDS REG GRANT',
  'UNICEF',
  'Union Bank Plc',
  'United Church of Canada',
  'United Nations (UN)',
  "United Nations Children's Fund (UNICEF)",
  'United Nations Conference on Trade and Development (UNCTAD)',
  'United Nations Development Programme (UNDP)',
  'United Nations Environment Programme (UNEP)',
  'United Nations High Commissioner for Refugees (UNHCR)',
  'United Nations Industrial Development Organization (UNIDO)',
  'United Nations Office for the Coordination of Humanitarian Affairs (OCHA)',
  'United Nations Office for the Coordination of Humanitarian Affairs (OCHA)',
  'United Nations Population Fund (SRH)',
  'United Nations Population Fund (UNFPA)',
  'United Nations Slavery Fund',
  'United Purpose',
  'United States African Development Foundation (USADF)',
  'United States Institute for Peace',
  'UR/FICR',
  'Urgent Action Fund-Africa',
  'USTADI foundation',
  'Voices for Change',
  'WANEP Regional office',
  'WAPIC Insurance',
  'WaterAid',
  'Wellspring Philanthropic Fund',
  'WEST AFRICA AIDS FOUNDATION',
  'WeTech',
  'William and Flora Hewlett Foundation',
  'WitsHealth Consortium',
  'Womankind',
  'Women Advocate for Vaccine Access',
  'Women in Europe for a Common Future (WECF)',
  'Women Worldwide Web',
  'World Accord - International Development Agency[44]',
  'World Association for Christian Communication',
  'World Education International',
  'World Food Programme (WFP)',
  'World Health Organization (WHO)',
  'World Hope International',
  'World Renew',
  'World Vision International',
  'WSSCC',
  'Yellow Wood Foundation',
  'Youth Alive Foundation',
  'YouthHub Africa',
  'Zambia Governance Foundation (ZGF)',
  'ZEE LINK NIGERIA',
];

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value, data_source) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  if (data_source === 'donor_list') {
    return inputLength === 0
      ? []
      : donor_list.filter(lang => lang.toLowerCase().slice(0, inputLength) === inputValue);
  } else {
    return inputLength === 0
      ? []
      : list.filter(lang => lang.toLowerCase().slice(0, inputLength) === inputValue);
  }
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => <div>{suggestion}</div>;

class AutosuggestInput extends React.Component {
  // Autosuggest is a controlled component.
  // This means that you need to provide an input value
  // and an onChange handler that updates this value (see below).
  // Suggestions also need to be provided to the Autosuggest,
  // and they are initially empty because the Autosuggest is closed.
  state = {
    value: '',
    suggestions: [],
  };

  componentDidMount() {
    if (this.props.response) {
      this.setState({
        value: this.props.response,
      });
    }
  }

  onChange = (event, { newValue }) => {
    ('onChange');
    this.setState({
      value: newValue,
    });
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(newValue);
    }
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value, this.props.data_source),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const { response, data_source, onChange } = this.props;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Type a programming language',
      value,
      onChange: this.onChange,
    };

    // Finally, render it!
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}
export default AutosuggestInput;



// WEBPACK FOOTER //
// ./src/ui/Autosuggest.js